import styled, {css} from 'styled-components'
import {NavLink} from 'react-router-dom'
import {
    makeButtonBaseStyle,
    makeButtonSizeStyle,
    makeButtonVariantStyle,
    StyledButtonProps
} from 'src/components/button/style.ts'

export const StyledButtonNavLink = styled(NavLink)<StyledButtonProps>(
    ({theme, ...props}) => css`
        ${makeButtonSizeStyle(theme)[props.$size ?? 'md'][props.$shape ?? 'rectangle']};
        ${makeButtonVariantStyle(theme, false)[props.$variant ?? 'primary']};
        ${makeButtonBaseStyle(theme, {
            $fullWidth: props.$fullWidth,
            $shape: props.$shape,
            disabled: false
        })};
    `
)

export const StyledButtonNavLinkDisabled = styled.a<StyledButtonProps>(
    ({theme, ...props}) => css`
        ${makeButtonSizeStyle(theme)[props.$size ?? 'md'][props.$shape ?? 'rectangle']};
        ${makeButtonVariantStyle(theme, true)[props.$variant ?? 'primary']};
        ${makeButtonBaseStyle(theme, {
            $fullWidth: props.$fullWidth,
            $shape: props.$shape,
            disabled: true
        })};
    `
)
